import { useContext } from 'react';
import '../contexts/TranslationContext.js';
import { StoreContext } from '../contexts/StoreContext.js';
import '../core/enums/GameSpecificTypes.js';
import '../core/enums/Chat.js';
import '../core/enums/GameModes.js';
import '../core/enums/IconTypes.js';
import '../core/enums/BetStatus.js';
import '../core/enums/PopupTypes.js';
import '../core/enums/ApiVersion.js';
import '../core/enums/RoundStatus.js';
import '../core/enums/RequestStatus.js';
import '../core/enums/FreeBetsStatus.js';
import '../core/enums/SocketEvents.js';
import '../core/enums/TranslationKeys.js';
import '../core/enums/ApiServiceTypes.js';
import '../core/enums/EnvironmentTypes.js';
import '../core/enums/DefaultQueryParams.js';
import '../core/enums/BetHistoryFilterTypes.js';
import '../core/enums/GameThemeTypes.js';
import '../core/enums/FetchDefaultPaths.js';
import '../core/enums/ResponseCodes.js';
import '../../moment-27179cac.js';
import '../../_commonjsHelpers-4c2b67c2.js';
import '../../TranslationService-32200248.js';
import '../../tslib.es6-80f01feb.js';
import 'axios';
import 'mobx';
import '../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../core/services/liveConnection/types.js';
import '../core/store/gameResultStore.js';
import '../core/services/sound/types.js';
import '../core/services/sound/SoundService.js';
import 'howler';
import '../core/services/sound/defaultSounds.js';
import '../core/services/api/types.js';
import '../core/services/api/BaseApiService.js';
import '../core/helpers/environmentBuilder.js';
import '../core/store/lobbyStore.js';
import '../core/store/roundInfoStore.js';
import '../core/store/userCountStore.js';
import '../core/store/gameConfigStore.js';
import '../core/helpers/parseQuery.js';
import '../core/enums/StatisticsSortingTypes.js';
import '../core/services/ApiServices.js';
import '../core/store/resultHashStore.js';
import '../core/store/userWinBetsStore.js';
import '../core/store/userSettingsStore.js';
import '../core/store/notificationStore.js';
import '../core/helpers/momentFormat.js';
import '../core/store/selectedResultInfoStore.js';
import '../core/store/chatStore.js';
import '../../table-line/t_types/enums/PopupTypes.js';
import '../core/helpers/parseNumberByPrecision.js';
import '../core/polyfill.js';

var useUserSettingsStore = function () {
    var userSettingsStore = useContext(StoreContext).userSettingsStore;
    return userSettingsStore;
};

export { useUserSettingsStore };
